export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const DATA_SOURCE_PROTOCOL = process.env.VUE_APP_DATA_SOURCE_PROTOCOL || "https";
export const I18N_LOCALE = process.env.VUE_APP_I18N_LOCALE || "en";
export const I18N_FALLBACK_LOCALE = process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en";
export const AWS_URL = process.env.VUE_APP_AWS_URL;
export const LANGUAGES_BASE_URL = process.env.VUE_APP_LANGUAGES_BASE_URL;